import { immerable } from 'immer';

export const DefaultLanguage = 'fr_FR';

interface ISupportedLanguageEntity {
	id: string;
	key: string;
	label: string;
}

const entityDefaults: ISupportedLanguageEntity = {
	id: '-1',
	key: '',
	label: '',
};

export class SupportedLanguageEntity implements ISupportedLanguageEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public key = entityDefaults.key;
	public label = entityDefaults.label;

	public static build(
		params: Partial<ISupportedLanguageEntity> = {}
	): SupportedLanguageEntity {
		const instance = new SupportedLanguageEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.key = params.key ?? entityDefaults.key;
		instance.label = params.label ?? entityDefaults.label;
		return instance;
	}
}
